const ZOOM_MAX_SECTIONS = 12.5;
const ZOOM_MIN_SECTIONS = 9;

const ZOOM_MAX_ROWS = 15;
const ZOOM_MIN_ROWS = 12.5;
const ZOOM_SELECTED_ROWS = 14;
const ZOOM_UNSELECTED_ROWS = 13;

const ZOOM_MAX_SEATS = 15;
const ZOOM_MIN_SEATS = 12.5;
const ZOOM_SELECTED_SEATS = 15;

const ZOOM_MAX_FITBOUNDS_SEATS = 12.501;
const ZOOM_MAX_FITBOUNDS_ROWS = 12.501;

const ZOOM_MIN_GA_SECTIONS = 9;
const ZOOM_MAX_GA_SECTIONS = 15.1;

// eslint-disable-next-line no-magic-numbers
const ZOOM_MAX_ZOOMLEVEL_SECTION = ZOOM_MAX_SECTIONS - 0.01;
const ZOOM_TOOLTIP_BREAKPOINT = 13.7;

// eslint-disable-next-line no-magic-numbers
const OFFSET_SEAT_CENTER_POSITION = [0, 90];
const OFFSET_TOOTIP = 25;

const CLICK_PADDING_WIDTH = 5;
const CLICK_PADDING_HEIGHT = 5;

const FLYTOHOME_DURATION = 100;

/*
 * Note: center coordinates for mobile remain the same as before
 *  TODO: make less magic... works for bills but probably not others? maybe it does based on scale. need to figure it out
 *  NOTE: the MAP_INITAL_CENTER commented out below should be used
 */
/* eslint-disable no-magic-numbers */
const MAP_INITAL_CENTER = [0.2, 0.17];
const MAP_INITAL_CENTER_PENCIL_BANNER = [0.2, 0.15];

// Note: bound box coordinates for mobile remain the same as before
const MAP_BOUND_BOX_COORDS = [
  [0.3, 0.03],
  [0.77, 0.03],
  [0.77, 0.53],
  [0.3, 0.53],
];

const STOP_ROWS = [
  [12.5, 4],
  [15, 19],
];

const STOP_SEATS = [
  [12.5, 2.2],
  [13, 3.4],
  [14, 6.4],
  [15, 12.7],
];
/* eslint-enable no-magic-numbers */

export default {
  ZOOM_MAX_SECTIONS,
  ZOOM_MIN_SECTIONS,

  ZOOM_MAX_ROWS,
  ZOOM_MIN_ROWS,
  ZOOM_SELECTED_ROWS,
  ZOOM_UNSELECTED_ROWS,

  ZOOM_MAX_SEATS,
  ZOOM_MIN_SEATS,
  ZOOM_SELECTED_SEATS,

  ZOOM_MAX_FITBOUNDS_SEATS,
  ZOOM_MAX_FITBOUNDS_ROWS,

  ZOOM_MIN_GA_SECTIONS,
  ZOOM_MAX_GA_SECTIONS,

  ZOOM_MAX_ZOOMLEVEL_SECTION,
  ZOOM_TOOLTIP_BREAKPOINT,

  STOP_ROWS,
  STOP_SEATS,

  OFFSET_SEAT_CENTER_POSITION,
  OFFSET_TOOTIP,

  CLICK_PADDING_WIDTH,
  CLICK_PADDING_HEIGHT,

  MAP_INITAL_CENTER,
  MAP_INITAL_CENTER_PENCIL_BANNER,
  MAP_BOUND_BOX_COORDS,

  FLYTOHOME_DURATION,
};
